<template>
  <div :class="[$style.wrapper, opened && $style.opened, error && $style.error]" @click="opened = !opened">
    {{ !value ? placeholder : value.label }}
    <div v-if="items && opened" :class="$style.items">
      <div v-for="(item, index) in items" :key="index" @click="$emit('input', item)">
        {{item.label}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'v-select',
  props: {
    value: null,
    error: Boolean,
    items: Array,
    placeholder: String,
  },
  data: () => ({
    opened: false,
  }),
  methods: {

  },
}
</script>
<style lang="scss" module>
.wrapper {
  font-size: 1.6rem;
  width: 29.5rem;
  height: 6rem;
  border: 2px solid #DADADA;
  background: #fff;
  border-radius: 0.5rem;
  padding: 1.9rem 1.7rem;
  position: relative;
  cursor: pointer;
  transition: border 0.3s ease;

  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.6rem 0.6rem 0 0.6rem;
    border-color: #00050a transparent transparent transparent;
    position: absolute;
    top: 50%;
    right: 1.6rem;
    transform: translateY(-50%);
    transition: transform 0.2s ease;
  }
}

.opened {
  &:after {
    transform: translateY(-50%)rotate(180deg);
  }
}

.items {
  position: absolute;
  background: #fff;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  border: 2px solid #DADADA;
  border-top: 0;
  left: -2px;
  right: -2px;
  top: 100%;
  margin-top: -2px;
  z-index: 100;
  transition: border 0.3s ease;

  & > div {
    padding: 0 1.7rem;
    height: 4rem;
    line-height: 4rem;
    &:hover {
      background: #F0F0F5;
    }
  }
}

.error {
  border-color: #ff0000;

  .items {
    border-color: #ff0000;
  }
}
</style>
